import { cross } from "react-icons-kit/icomoon/cross";
import { loop } from "react-icons-kit/icomoon/loop";
import { plus } from "react-icons-kit/icomoon/plus";

export const CustomerActionIconGroup = {
  Add: {
    iconProps: {
      icon: plus,
      size: 16
    },
    tooltipTitle: "Add",
  },
  Update: {
    iconProps: {
      icon: loop,
      size: 24
    },
    tooltipTitle: "Update",
  },
  RefreshLogService: {
    iconProps: {
      icon: loop,
      size: 24
    },
    tooltipTitle: "Refresh Log Service",
  },
  Remove: {
    iconProps: {
      icon: cross,
      size: 16
    },
    tooltipTitle: "Remove",
  },
};





// WEBPACK FOOTER //
// ./src/components/diagnostics/Customer/schemas/CustomerActionIconGroup.js